import ExpandLessRoundedIcon from '@mui/icons-material/ExpandLessRounded';
import ExpandMoreRoundedIcon from '@mui/icons-material/ExpandMoreRounded';
import MenuBookOutlinedIcon from '@mui/icons-material/MenuBookOutlined';
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import GlossaryModal from '../modal/glossaryModal';
import { openGlossaryModal } from '../actions/glossaryActions';
import Loading from './loading';

const GlossarySection = () => {
  const dispatch = useDispatch();
  const { id } = useParams();
  // Selecting the sub-object keeps this stable while the modal is in use, so
  // scrolling the modal never re-renders the panel.
  const preview = useSelector((state) => state.glossary.preview);
  const isModalOpen = useSelector((state) => state.glossary.list.isOpen);
  const [isExpanded, setIsExpanded] = useState(true);

  const { items, totalCount, loading, hasError } = preview;

  // Nothing to say when the client has no glossary — hide the section rather
  // than leave a dead heading in the panel.
  if (items !== null && items.length === 0 && !hasError) return null;

  return (
    <div id="glossary" className="notesContent">
      <div className="glossaryHeader" onClick={() => setIsExpanded((prev) => !prev)}>
        <div className="notesTitle">
          <MenuBookOutlinedIcon sx={{ fontSize: '18px' }} />
          Glossary
          {totalCount > 0 && <span className="glossaryBadge">{totalCount}</span>}
        </div>
        {isExpanded ? (
          <ExpandLessRoundedIcon sx={{ fontSize: '20px', opacity: 0.6 }} />
        ) : (
          <ExpandMoreRoundedIcon sx={{ fontSize: '20px', opacity: 0.6 }} />
        )}
      </div>

      {isExpanded && (
        <>
          <div className="glossarySubtitle">Terms set by the client in Transcription Config.</div>

          {loading && items === null && <Loading sx={{ height: '80px' }} />}

          {hasError && items === null && !loading && (
            <div className="glossarySubtitle">Could not load the glossary.</div>
          )}

          {items?.length > 0 && (
            <>
              <div className="glossaryChips">
                {items.map((term, index) => (
                  <span className="glossaryChip" key={term?.Id ?? `glossary-${index}`}>
                    {term?.Name}
                  </span>
                ))}
              </div>
              <span
                className="glossaryLink"
                onClick={() => dispatch(openGlossaryModal(id))}
                role="button"
                tabIndex={0}
                onKeyDown={(e) => e.key === 'Enter' && dispatch(openGlossaryModal(id))}
              >
                View full glossary
              </span>
            </>
          )}
        </>
      )}

      {/* Mounted conditionally so the search box resets on every open. */}
      {isModalOpen && <GlossaryModal />}
    </div>
  );
};

export default GlossarySection;
